import MessagingTemplateForm from './messagingTemplateForm';

export default MessagingTemplateForm;
